import { render, staticRenderFns } from "./BaseNestableDialog.vue?vue&type=template&id=2942ed4e&scoped=true&"
import script from "./BaseNestableDialog.vue?vue&type=script&lang=js&"
export * from "./BaseNestableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942ed4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
